import { useState } from 'react';
import './App.css';
import { Header } from './components/';
import Image1 from './assets/1.jpg';
import Image2 from './assets/2.jpg';
import Image3 from './assets/3.jpg';
import Image4 from './assets/4.jpg';
import Image5 from './assets/5.jpg';
import Image6 from './assets/6.jpg';

function App() {

  const [cartTotals, setCartTotals] = useState(0);   
  const [cartContents, setCartContents] = useState([]);
  const [products, setProducts] = useState([
    {id:1, name: 'Deadpool & Wolverine', price: 19.99, img : Image1},
    {id:2, name: 'The Marvels', price: 16.99, img : Image2},
    {id:3, name: 'Ant Man', price: 29.99, img : Image3},
    {id:4, name: 'Guardians of the Galaxy', price: 18.99, img : Image4},
    {id:5, name: 'Avengers End Game', price: 24.99, img : Image5},
    {id:6, name: 'Black Widow', price: 32.99, img : Image6}]);

    
    console.log(cartContents);
  
  return (
    <>
    <div className="container mx-auto">
      <Header 
      cartTotals={cartTotals} 
      setCartTotals={setCartTotals} 
      cartContents={cartContents}
      products={products}
      setCartContents={setCartContents} />


    </div>
    
    
    </>
  );
}

export default App;
